/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DistributionChannelFormData,
    DistributionChannelFormDataFromJSON,
    DistributionChannelFormDataToJSON,
    DistributionChannelFormValidationData,
    DistributionChannelFormValidationDataFromJSON,
    DistributionChannelFormValidationDataToJSON,
    DistributionChannelFormWarningsData,
    DistributionChannelFormWarningsDataFromJSON,
    DistributionChannelFormWarningsDataToJSON,
} from '../models';

export interface ApiDistributionChannelFormCreatePostRequest {
    distributionChannelFormData?: DistributionChannelFormData;
}

export interface ApiDistributionChannelFormDataGetRequest {
    id?: number;
}

export interface ApiDistributionChannelFormUpdatePostRequest {
    distributionChannelFormData?: DistributionChannelFormData;
}

export interface ApiDistributionChannelFormValidatePostRequest {
    update?: boolean;
    distributionChannelFormData?: DistributionChannelFormData;
}

export interface ApiDistributionChannelFormWarningsPostRequest {
    distributionChannelFormData?: DistributionChannelFormData;
}

/**
 * no description
 */
export class DistributionChannelFormApi extends runtime.BaseAPI {

    /**
     */
    async apiDistributionChannelFormCreatePostRaw(requestParameters: ApiDistributionChannelFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/DistributionChannelForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributionChannelFormDataToJSON(requestParameters.distributionChannelFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDistributionChannelFormCreatePost(requestParameters: ApiDistributionChannelFormCreatePostRequest): Promise<void> {
        await this.apiDistributionChannelFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiDistributionChannelFormDataGetRaw(requestParameters: ApiDistributionChannelFormDataGetRequest): Promise<runtime.ApiResponse<DistributionChannelFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/DistributionChannelForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributionChannelFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiDistributionChannelFormDataGet(requestParameters: ApiDistributionChannelFormDataGetRequest): Promise<DistributionChannelFormData> {
        const response = await this.apiDistributionChannelFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiDistributionChannelFormUpdatePostRaw(requestParameters: ApiDistributionChannelFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/DistributionChannelForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributionChannelFormDataToJSON(requestParameters.distributionChannelFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiDistributionChannelFormUpdatePost(requestParameters: ApiDistributionChannelFormUpdatePostRequest): Promise<void> {
        await this.apiDistributionChannelFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiDistributionChannelFormValidatePostRaw(requestParameters: ApiDistributionChannelFormValidatePostRequest): Promise<runtime.ApiResponse<DistributionChannelFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.update !== undefined) {
            queryParameters['update'] = requestParameters.update;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/DistributionChannelForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributionChannelFormDataToJSON(requestParameters.distributionChannelFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributionChannelFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiDistributionChannelFormValidatePost(requestParameters: ApiDistributionChannelFormValidatePostRequest): Promise<DistributionChannelFormValidationData> {
        const response = await this.apiDistributionChannelFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiDistributionChannelFormWarningsPostRaw(requestParameters: ApiDistributionChannelFormWarningsPostRequest): Promise<runtime.ApiResponse<DistributionChannelFormWarningsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/DistributionChannelForm/Warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributionChannelFormDataToJSON(requestParameters.distributionChannelFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributionChannelFormWarningsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiDistributionChannelFormWarningsPost(requestParameters: ApiDistributionChannelFormWarningsPostRequest): Promise<DistributionChannelFormWarningsData> {
        const response = await this.apiDistributionChannelFormWarningsPostRaw(requestParameters);
        return await response.value();
    }

}
